import { SERVICE_NAMES } from '../core/constants';
import { InternalSDKOperations, LanguageCode } from '../types';
import { BaseService } from './base-service';
import { Curriculum } from '../types/curriculum';
import { NetworkDetectionManager } from '../utils/network-detection-manager';

interface GetCurriculumParams {
  targetLanguage: LanguageCode;
  nativeLanguage: LanguageCode;
  version?: string;
}

export class CurriculumService extends BaseService {
  protected serviceName = SERVICE_NAMES.CURRICULUM;

  constructor(
    internalOps: InternalSDKOperations,
    networkManager?: NetworkDetectionManager,
  ) {
    super(internalOps, networkManager);
  }

  async getCurriculum({
    targetLanguage,
    nativeLanguage,
    version = 'v1',
  }: GetCurriculumParams): Promise<{ curriculum: Curriculum }> {
    const response = await this.internalOps.makeRequest<{
      curriculum: Curriculum;
    }>(SERVICE_NAMES.CURRICULUM, 'getCurriculum', undefined, version, {
      method: 'GET',
      queryParams: {
        targetLanguage,
        nativeLanguage,
      },
    });
    return response.data;
  }
}
